// City type definition
export type City =
  | "Pune"
  | "Mumbai"
  | "Nagpur"
  | "Ahmedabad"
  | "Surat"
  | "Nashik"
  | "Kolhapur"
  | "Sambhajinagar"
  | "Bengaluru"
  | "Hyderabad"
  | "Lucknow"
  | "Goa"
  | "Delhi";

// Google Form IDs for each city
export const GOOGLE_FORM_ID_PUNE = process.env.REACT_APP_GOOGLE_FORM_ID;
export const GOOGLE_FORM_ID_MUMBAI =
  process.env.REACT_APP_GOOGLE_FORM_ID_MUMBAI; // Fallback to Pune if not set
export const GOOGLE_FORM_ID_NAGPUR =
  process.env.REACT_APP_GOOGLE_FORM_ID_NAGPUR;
export const GOOGLE_FORM_ID_AHMEDABAD =
  process.env.REACT_APP_GOOGLE_FORM_ID_AHMEDABAD;
export const GOOGLE_FORM_ID_SURAT = process.env.REACT_APP_GOOGLE_FORM_ID_SURAT;
export const GOOGLE_FORM_ID_NASHIK =
  process.env.REACT_APP_GOOGLE_FORM_ID_NASHIK;
export const GOOGLE_FORM_ID_KOLHAPUR =
  process.env.REACT_APP_GOOGLE_FORM_ID_KOLHAPUR;
export const GOOGLE_FORM_ID_SAMBHAJINAGAR =
  process.env.REACT_APP_GOOGLE_FORM_ID_SAMBHAJINAGAR;
export const GOOGLE_FORM_ID_BENGALURU =
  process.env.REACT_APP_GOOGLE_FORM_ID_BENGALURU;
export const GOOGLE_FORM_ID_HYDERABAD =
  process.env.REACT_APP_GOOGLE_FORM_ID_HYDERABAD;
export const GOOGLE_FORM_ID_LUCKNOW =
  process.env.REACT_APP_GOOGLE_FORM_ID_LUCKNOW;
export const GOOGLE_FORM_ID_GOA = process.env.REACT_APP_GOOGLE_FORM_ID_GOA;
export const GOOGLE_FORM_ID_DELHI = process.env.REACT_APP_GOOGLE_FORM_ID_DELHI;

// Legacy export for backward compatibility
export const GOOGLE_FORM_ID = GOOGLE_FORM_ID_PUNE;

// City-specific localities
export const CITY_LOCALITIES: Record<City, string[]> = {
  Pune: [
    "Shivajinagar",
    "Kothrud",
    "Hadapsar",
    "Camp",
    "Hinjewadi",
    "Viman nagar",
    "Peth",
    "Baner",
    "PCMC",
    "Other",
  ],
  Mumbai: [
    "Andheri",
    "Bandra",
    "Borivali",
    "Colaba",
    "Dadar",
    "Goregaon",
    "Juhu",
    "Malad",
    "Powai",
    "Thane",
    "Worli",
    "Other",
  ],
  Nagpur: [
    "Sitabuldi",
    "South Ambazari",
    "Sadar",
    "Mahal",
    "Dharampeth",
    "Laxmi Nagar",
    "Wadi",
    "Itwari",
    "Butibori",
    "Other",
  ],
  Ahmedabad: [
    "Navrangpura",
    "Vastrapur",
    "Paldi",
    "Satellite",
    "Thaltej",
    "Bodakdev",
    "Naranpura",
    "Maninagar",
    "Gota",
    "Other",
  ],
  Surat: [
    "Adajan",
    "Udhna",
    "Athwa",
    "Varachha",
    "Piplod",
    "Vesu",
    "City Light",
    "Rander",
    "Bhestan",
    "Other",
  ],
  Nashik: [
    "College Road",
    "Rashtriya Shala",
    "Satpur",
    "Gangapur Road",
    "Deolali",
    "Panchavati",
    "Makhmalabad",
    "Nehru Road",
    "Old Nashik",
    "Other",
  ],
  Kolhapur: [
    "Shivaji Nagar",
    "Rajaram Road",
    "Udyamnagar",
    "Kagal Road",
    "Shagem",
    "Shivaji Chowk",
    "Gokul Road",
    "Ichalkaranji Road",
    "Old Shahupuri",
    "Other",
  ],
  Sambhajinagar: [
    "Camp",
    "Cidco",
    "N-1",
    "Chikalthana",
    "Garkheda",
    "Hingoli",
    "Yashwantnagar",
    "Kubera",
    "Other",
  ],
  Bengaluru: [
    "Koramangala",
    "Indiranagar",
    "Whitefield",
    "MG Road",
    "Jayanagar",
    "Hebbal",
    "HSR Layout",
    "Electronic City",
    "Yelahanka",
    "Other",
  ],
  Hyderabad: [
    "Banjara Hills",
    "Jubilee Hills",
    "Gachibowli",
    "Madhapur",
    "Secunderabad",
    "Hitech City",
    "Kukatpally",
    "Ameerpet",
    "Charminar",
    "Other",
  ],
  Lucknow: [
    "Hazratganj",
    "Gomti Nagar",
    "Aliganj",
    "Indira Nagar",
    "Mahanagar",
    "Vikas Nagar",
    "Chowk",
    "Mitraon",
    "Krishna Nagar",
    "Other",
  ],
  Goa: ["North Goa", "South Goa", "Other"],
  Delhi: [
    "Central Delhi",
    "North Delhi",
    "South Delhi",
    "East Delhi",
    "West Delhi",
    "New Delhi",
    "Gurugram",
    "Noida",
    "Dwarka",
    "Other",
  ],
};

// Field mapping (same for both cities)
export const FIELD_MAP: Record<number, string> = {
  1: "entry.2092238618", // name
  2: "entry.1556369182", // age
  3: "entry.479301265", // gender
  4: "entry.1753222212", // locality
  5: "entry.588393791", // contact
  6: "entry.1815576712", // instagram
  7: "entry.1550603826", // who to date
  8: "entry.2029594214", // preferred age range ✅
  9: "entry.502432079", // preferred day
  10: "entry.1553412802", // preferred time ✅
  11: "entry.1886700422", // type of date ✅
  12: "entry.2129740992", // budget ✅
  13: "entry.672163627", // occupation
  14: "entry.1052184394", // hobbies
  15: "entry.1184707000", // introvert/extrovert scale
  16: "entry.1039569255", // smoke ✅ verify this manually once
  17: "entry.416643592", // drink
  18: "entry.1967912402", // pets
  19: "entry.795047534", // 3 words description
  20: "entry.1295272024", // green flag
  21: "entry.584456423", // red flag
  22: "entry.1775258709", // cross-religion ✅
  23: "entry.1843725721", // confirm participation ✅
};

export const OTHER_FIELD_MAP: Record<number, string> = {
  3: "entry.479301265.other_option_response", // gender
  4: "entry.1753222212.other_option_response", // locality
  7: "entry.1550603826.other_option_response", // who to date
  22: "entry.1775258709.other_option_response", // cross-religion
};

// Helper function to get form ID by city
export const getFormIdByCity = (city: City | null) => {
  const formIdMap: Record<City, string | undefined> = {
    Pune: GOOGLE_FORM_ID_PUNE,
    Mumbai: GOOGLE_FORM_ID_MUMBAI,
    Nagpur: GOOGLE_FORM_ID_NAGPUR,
    Ahmedabad: GOOGLE_FORM_ID_AHMEDABAD,
    Surat: GOOGLE_FORM_ID_SURAT,
    Nashik: GOOGLE_FORM_ID_NASHIK,
    Kolhapur: GOOGLE_FORM_ID_KOLHAPUR,
    Sambhajinagar: GOOGLE_FORM_ID_SAMBHAJINAGAR,
    Bengaluru: GOOGLE_FORM_ID_BENGALURU,
    Hyderabad: GOOGLE_FORM_ID_HYDERABAD,
    Lucknow: GOOGLE_FORM_ID_LUCKNOW,
    Goa: GOOGLE_FORM_ID_GOA,
    Delhi: GOOGLE_FORM_ID_DELHI,
  };

  return (city && formIdMap[city]) || GOOGLE_FORM_ID_PUNE;
};

// Helper function to get localities by city
export const getLocalitiesByCity = (city: City | null): string[] => {
  if (!city) return CITY_LOCALITIES.Pune;
  return CITY_LOCALITIES[city];
};
